import React from 'react'

const CHUNK_RELOAD_KEY = 'uoa-chunk-reload'

const isChunkLoadError = (error) => {
  if (!error) return false

  const message = String(error.message || error)
  return error.name === 'ChunkLoadError' || /Loading chunk .* failed/i.test(message)
}

export function lazyWithRetry(importFactory) {
  return React.lazy(() =>
    importFactory().catch((error) => {
      if (!isChunkLoadError(error)) {
        throw error
      }

      const hasReloaded = window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1'

      if (!hasReloaded) {
        window.sessionStorage.setItem(CHUNK_RELOAD_KEY, '1')
        window.location.reload()
        return new Promise(() => {})
      }

      window.sessionStorage.removeItem(CHUNK_RELOAD_KEY)
      throw error
    }),
  )
}

export default lazyWithRetry
